declare var moment: any

/** What a change preview from the API has come back as, by the time a dialog renders it. */
export type ChangePreview =
  | { status: "loading" }
  | { status: "error" }
  | { status: "ready"; dueToday: number; credit: number; nextBillDate: string | null }

const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
const count = new Intl.NumberFormat("en-US")

/** Dialog amounts always show cents: "$10.00", "$0.00". */
export const money = (amount: number) => usd.format(amount)

export const number = (n: number) => count.format(n)

/** "Nov 3, 2026". moment, because plan dates arrive as "2026-11-03 16:11:20" as well as ISO. */
export const billDate = (date: string | number | Date) => moment(date).format("MMM D, YYYY")

export const packs = (n: number) => `${n} pack${n === 1 ? "" : "s"}`
